import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const Privacy = () => {
  return (
    <div className="min-h-screen pt-20">
      <section className="py-20 px-4 bg-primary-lime">
        <div className="container mx-auto max-w-4xl">
          <Button variant="outline" className="mb-8" asChild>
            <Link to="/">
              <ArrowLeft className="mr-2" size={16} />
              Back to Home
            </Link>
          </Button>
          <h1 className="font-serif text-5xl md:text-6xl font-bold text-black mb-6">
            Privacy Policy
          </h1>
          <p className="text-xl text-gray-700">
            Last updated: December 23, 2024
          </p>
        </div>
      </section>

      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto max-w-4xl prose prose-lg">
          <div className="space-y-8">
            <div>
              <h2 className="font-serif text-3xl font-bold text-black mb-4">Introduction</h2>
              <p className="text-gray-700 leading-relaxed">
                Skyretieducore ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-3xl font-bold text-black mb-4">Information We Collect</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We collect information that you provide directly to us, including:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Name and contact information (email, phone number)</li>
                <li>Company or organization name</li>
                <li>Project details and requirements</li>
                <li>Communication preferences</li>
                <li>Payment and billing information</li>
              </ul>
            </div>

            <div>
              <h2 className="font-serif text-3xl font-bold text-black mb-4">How We Use Your Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Provide, maintain, and improve our services</li>
                <li>Process your transactions and send related information</li>
                <li>Respond to your comments, questions, and requests</li>
                <li>Send you technical notices and support messages</li>
                <li>Communicate about products, services, and events</li>
                <li>Monitor and analyze trends and usage</li>
              </ul>
            </div>

            <div>
              <h2 className="font-serif text-3xl font-bold text-black mb-4">Information Sharing</h2>
              <p className="text-gray-700 leading-relaxed">
                We do not sell, trade, or rent your personal information to third parties. We may share your information with:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Service providers who assist in our operations</li>
                <li>Professional advisors such as lawyers and accountants</li>
                <li>Law enforcement when required by law</li>
              </ul>
            </div>

            <div>
              <h2 className="font-serif text-3xl font-bold text-black mb-4">Data Security</h2>
              <p className="text-gray-700 leading-relaxed">
                We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-3xl font-bold text-black mb-4">Your Rights</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                You have the right to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>Access and receive a copy of your personal data</li>
                <li>Rectify inaccurate or incomplete data</li>
                <li>Request deletion of your data</li>
                <li>Object to processing of your data</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </div>

            <div>
              <h2 className="font-serif text-3xl font-bold text-black mb-4">Cookies and Tracking</h2>
              <p className="text-gray-700 leading-relaxed">
                We use cookies and similar tracking technologies to improve your experience on our website. You can control cookies through your browser settings.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-3xl font-bold text-black mb-4">Changes to This Policy</h2>
              <p className="text-gray-700 leading-relaxed">
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
              </p>
            </div>

            <div>
              <h2 className="font-serif text-3xl font-bold text-black mb-4">Contact Us</h2>
              <p className="text-gray-700 leading-relaxed">
                If you have questions about this Privacy Policy, please contact us at:
              </p>
              <p className="text-gray-700 mt-4">
                Email: privacy@skyretieducore.com<br />
                Phone: +1 (555) 123-4567
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
